/* Aveloz Logo Swap — Rebranding Jun 2026 */
(function() {
  var NAVY = 'https://cdn.shopify.com/s/files/1/0794/6082/7372/files/logo-aveloz-navy.png';
  var WHITE = 'https://cdn.shopify.com/s/files/1/0794/6082/7372/files/logo-aveloz-white.png';
  var template = document.body ? document.body.dataset.template : '';

  function swapLogos() {
    var isDark = document.body.classList.contains('av-dark-header') ||
                 false;
    var imgs = document.querySelectorAll('.av-logo img, .ant-logo__img, .av-logo__img, [class*="logo"] img');
    imgs.forEach(function(img) {
      var h = img.naturalHeight || 0;
      var w = img.naturalWidth || 0;
      // Só troca se for o logo atual (ou qualquer img dentro do logo)
      if (img.closest('.av-logo, .ant-logo, .ant-logo__img, header')) {
        img.src = isDark ? WHITE : NAVY;
        img.srcset = '';
        img.style.maxHeight = '50px';
        img.style.maxWidth = '200px';
        img.style.width = 'auto';
        img.style.height = 'auto';
        img.style.objectFit = 'contain';
        img.style.filter = 'none'; // remover filtros antigos
        img.setAttribute('data-logo-swapped', '1');
      }
    });
  }

  // Swap imediato
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', swapLogos);
  } else {
    swapLogos();
  }
  // Garantia para temas com carregamento lazy
  setTimeout(swapLogos, 300);
  setTimeout(swapLogos, 800);

  // Observar mudanças de scroll para header transparente em coleções
  if (document.body && document.body.dataset.template === 'collection') {
    var header = document.querySelector('header, .av-header, .ant-header-section');
    if (header) {
      var observer = new MutationObserver(swapLogos);
      observer.observe(header, { attributes: true, attributeFilter: ['class'] });
    }
  }
})();
